import _defineProperty from "/data/buildAgent/sid-teamcity-agent-01/work/7ee7b29b3220b2e5/portals/UPGRADE/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/data/buildAgent/sid-teamcity-agent-01/work/7ee7b29b3220b2e5/portals/UPGRADE/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import _ from 'lodash';
import { isPromise } from '@jutro/platform';
import { log } from '@jutro/logger';
import { showAlert } from './alertHelper';
import { navigateTo } from './navigationHelper';
import { getErrorCategory } from './errorCategorizer';
export function invokeAction(name, props, context, onSuccess, onFailure) {
  var actionFunction = props.function;
  var actionArgs = props.args;
  if (!actionFunction || _.isString(actionFunction)) {
    log.error("Could not resolve action function: \"".concat(actionFunction || name, "\""));
    return undefined;
  }
  if (actionArgs) {
    actionArgs = _mapInstanceProperty(actionArgs).call(actionArgs, function (prop) {
      return context[prop];
    });
  }
  var result;
  var resultException;
  try {
    result = actionArgs ? actionFunction.apply(void 0, _toConsumableArray(actionArgs)) : actionFunction();
  } catch (ex) {
    result = false;
    resultException = ex;
  }
  return {
    name: name,
    result: result,
    resultException: resultException,
    progress: props.progress,
    success: props.success,
    failure: props.failure,
    onSuccess: onSuccess,
    onFailure: onFailure
  };
}
export function actionResultWithPaths(result, successPath, failurePath, progressMsg) {
  var actionObject = {
    name: 'unnamed',
    result: result
  };
  if (progressMsg !== undefined) {
    actionObject.progress = {
      message: progressMsg
    };
  }
  if (successPath !== undefined) {
    actionObject.success = {
      path: successPath
    };
  }
  if (failurePath !== undefined) {
    actionObject.failure = {
      path: failurePath
    };
  }
  return actionObject;
}
export function handleAction(actionObject, instance, translator) {
  var name, result, resultException, progress, success, failure, onSuccess, onFailure, _ref, message, _ref2, to, toMessage, _ref3, failTo, failToMessage, onAlert, onNavigate, data, computedFailTo, errorData, errorCategory, knockoutPath, errorProps;
  return _regeneratorRuntime().async(function handleAction$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        if (!instance) {
          _context2.next = 4;
          break;
        }
        if (!(!instance.setState || !instance.props || !instance.props.history)) {
          _context2.next = 4;
          break;
        }
        log.error('"Instance" provided to AsyncLink.handleAction does not have "setState" or "history" props');
        return _context2.abrupt("return");
      case 4:
        name = actionObject.name, result = actionObject.result, resultException = actionObject.resultException, progress = actionObject.progress, success = actionObject.success, failure = actionObject.failure, onSuccess = actionObject.onSuccess, onFailure = actionObject.onFailure;
        _ref = progress || {}, message = _ref.message;
        _ref2 = success || {}, to = _ref2.path, toMessage = _ref2.message;
        _ref3 = failure || {}, failTo = _ref3.path, failToMessage = _ref3.message;
        onAlert = showAlert;
        onNavigate = navigateTo;
        if (isPromise(result)) {
          _context2.next = 20;
          break;
        }
        if (!(result !== false)) {
          _context2.next = 15;
          break;
        }
        if (onSuccess) {
          onSuccess(name, result);
        }
        if (to && onNavigate) {
          onNavigate(instance, to, result);
        } else if (toMessage && onAlert) {
          onAlert(translator(toMessage));
        }
        return _context2.abrupt("return");
      case 15:
        if (!(resultException !== undefined && resultException !== false)) {
          _context2.next = 19;
          break;
        }
        if (onFailure) {
          onFailure(name, resultException);
        }
        if (failTo && onNavigate) {
          onNavigate(instance, failTo, resultException);
        } else if (failToMessage && onAlert) {
          onAlert(translator(failToMessage));
        }
        return _context2.abrupt("return");
      case 19:
        return _context2.abrupt("return");
      case 20:
        _context2.prev = 20;
        if (instance) {
          instance.setState({
            loading: true,
            message: translator(message)
          });
        }
        _context2.next = 24;
        return _regeneratorRuntime().awrap(result);
      case 24:
        data = _context2.sent;
        if (instance) {
          instance.setState({
            loading: false,
            message: null
          });
        }
        if (data !== false) {
          if (onSuccess) {
            onSuccess(name, data);
          }
          if (to && onNavigate) {
            onNavigate(instance, to, data);
          } else if (toMessage && onAlert) {
            onAlert(translator(toMessage));
          }
        }
        _context2.next = 45;
        break;
      case 29:
        _context2.prev = 29;
        _context2.t0 = _context2["catch"](20);
        computedFailTo = failTo;
        if (_context2.t0 instanceof Error) {
          log.error("AsyncLink: ".concat(_context2.t0));
        }
        if (instance) {
          instance.setState({
            loading: false,
            message: null
          });
        }
        if (!(_context2.t0 === false)) {
          _context2.next = 36;
          break;
        }
        return _context2.abrupt("return");
      case 36:
        if (onFailure) {
          onFailure(name, _context2.t0);
        }
        if (!(_context2.t0 === false)) {
          _context2.next = 39;
          break;
        }
        return _context2.abrupt("return");
      case 39:
        errorData = _context2.t0;
        errorCategory = getErrorCategory(_context2.t0.errorCode || _context2.t0);
        knockoutPath = errorCategory.knockoutPath, errorProps = _objectWithoutProperties(errorCategory, ["knockoutPath"]);
        if (knockoutPath) {
          computedFailTo = knockoutPath;
        }
        if (!_.isEmpty(errorProps)) {
          errorData = _objectSpread({}, errorProps, {
            error: _context2.t0
          });
        }
        if (computedFailTo && onNavigate) {
          onNavigate(instance, computedFailTo, errorData);
        } else if (failToMessage && onAlert) {
          onAlert(translator(failToMessage));
        }
      case 45:
      case "end":
        return _context2.stop();
    }
  }, null, null, [[20, 29]], Promise);
}
export function checkActionIntegrity(events, props, context) {
  if (!events || !props || !context) {
    return;
  }
  _forEachInstanceProperty(events).call(events, function (evt) {
    var actionProps = props[evt];
    if (actionProps) {
      if (_.isString(actionProps.function)) {
        log.error("Could not resolve action function: \"".concat(actionProps.function, "\". Check return from \"getActionFunctions()\""));
        return;
      }
      if (actionProps.function && actionProps.args) {
        var _context;
        var missing = _reduceInstanceProperty(_context = actionProps.args).call(_context, function (list, prop) {
          if (!Object.prototype.hasOwnProperty.call(context, prop)) {
            list.push(prop);
          }
          return list;
        }, []);
        if (missing.length !== 0) {
          log.error("Could not resolve action function arguments from action context: \"".concat(actionProps.name, "(").concat(missing, ")\". Check return from \"getActionContext()\""));
        }
      }
    }
  });
}